/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'qrcode': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#686a7a" clip-path="url(#svgicon_qrcode_a)"><path pid="0" d="M3 10h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm1-6h4v4H4V4ZM21 2h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-1 4h-2V4h2v2ZM7 16H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4H4v-2h2v2ZM15 2h-4v2h4V2ZM12 9h3V7h-2V5h-2v3a1 1 0 0 0 1 1ZM16 10v4a1 1 0 0 0 1 1h3v1h2v-2a1 1 0 0 0-1-1h-3v-2h4V9h-5a1 1 0 0 0-1 1ZM10 15v-3a1 1 0 0 0-1-1H2v2h2v2h2v-2h2v2h2ZM15 13h-4v2h4v-2ZM15 10h-3v2h3v-2ZM15 18v2h-4v-1H9v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2h5v-2h-6a1 1 0 0 0-1 1Z"/><path pid="1" d="M14 16h-2v3h2v-3ZM11 16H9v2h2v-2ZM22 20h-4v2h4v-2Z"/></g><defs><clipPath id="svgicon_qrcode_a"><path pid="2" _fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
